// extracted by mini-css-extract-plugin
module.exports = {"login-box":"login_login-box___mZBd","content-right":"login_content-right__y2XQx","logo":"login_logo__BPv8H"};